/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LpisSubjectDto { 
    concerned?: boolean;
    ctverec?: string;
    eko?: number;
    idFb?: number;
    idUz?: number;
    katuzeKod?: number;
    katuzeNazev?: string;
    kultura?: number;
    kulturaNazev?: string;
    kulturaod?: string;
    mapovylis5?: string;
    mapovylist?: string;
    nkodfb?: string;
    platnyod?: string;
    stavK?: string;
    subjAdresa?: string;
    subjIco?: string;
    subjJmeno?: string;
    subjNazev?: string;
    subjPrijmeni?: string;
    subjTitulPredJmenem?: string;
    subjTitulZaJmenem?: string;
    subjType?: string;
    subjectId?: number;
    svazitost?: number;
    vymeram?: number;
    vyska?: number;
    zkodfb?: string;
}

